import React, { useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { membershipStats } from '../../../store/actions/StatsAction';
import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';
import NoFanclub from './NoFanclub';
import MembershipPlansRepartition from './MembershipPlansRepartition';
import { Card, CardContent, Typography } from '@mui/material';
import { BlackPaper } from '../surface/Paper';
import { styled } from '@mui/material/styles';

const UppercaseTypography = styled(Typography)({
  textTransform: 'uppercase',
});

const Membership = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  // Use selector hooks instead of connect
  const fanclub = useSelector(state => state.membership.selectedFanclub);
  
  // Dispatch action function wrapped in useCallback
  const fetchMembershipStats = useCallback((membershipId) => {
    dispatch(membershipStats(membershipId));
  }, [dispatch]);

  useEffect(() => {
    if (!fanclub) return;
    fetchMembershipStats(fanclub.Membership__);
  }, [fanclub, fetchMembershipStats]);

  if (!fanclub) {
    return (
      <Card component={BlackPaper} style={{height:'100%'}}>
        <CardContent>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <UppercaseTypography align="center" variant={'h6'}>
                {t('dashboard_membership_title')}
              </UppercaseTypography>
            </Grid>
            <Grid item xs={12}>
              <NoFanclub/>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    );
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <MembershipPlansRepartition/>
      </Grid>
    </Grid>
  );
};

export default Membership;